import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['seller', 'rule']
  static values = { url: String }

  connect () {
    // Don't reload if rules are already populated (e.g., after validation error)
    if (this.hasRuleTarget && this.ruleTarget.options.length > 1) {
      return
    }

    if (this.hasSellerTarget && this.sellerTarget.value) {
      this.loadCarrierRules()
    }
  }

  loadCarrierRules () {
    const sellerId = this.sellerTarget.value

    if (!sellerId) {
      this.clearRuleOptions()
      return
    }

    // Save currently selected value before reloading
    const selectedValue = this.ruleTarget.value

    const url = this.urlValue + '?seller_id=' + sellerId

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then(({ rules }) => {
        this.ruleTarget.innerHTML = '<option value=""></option>'
        rules.forEach((rule) => {
          const option = document.createElement('option')
          option.value = rule.id
          option.innerHTML = rule.name
          // Re-select the previously selected value
          if (selectedValue && option.value === selectedValue) {
            option.selected = true
          }
          this.ruleTarget.appendChild(option)
        })

        // Dispatch event for slim-select to refresh
        this.ruleTarget.dispatchEvent(new CustomEvent('slim-select:refresh'))
      })
  }

  clearRuleOptions () {
    this.ruleTarget.innerHTML = '<option value=""></option>'
    this.ruleTarget.dispatchEvent(new CustomEvent('slim-select:refresh'))
  }
}
